"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconActionElement = exports.renderIconAction = exports.withIconAction = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/overlay/tooltip");
require("@/components/common/icon");
/**
 * close·delete·dismiss·next·prev-button처럼 아이콘 하나로 단일 행동을 알리는
 * 시맨틱 버튼이 공유하는 tooltip 위치·disabled 상태와 클릭 배선. 크기는 필요한 컴포넌트만 스스로 갖는다.
 * 행동의 의미는 이벤트 이름과 레이블로 구분되므로 컴포넌트 자체는 합치지 않는다.
 */
const withIconAction = (Base, eventName) => {
    class IconActionElement extends Base {
        constructor() {
            super(...arguments);
            this.tooltipPlacement = 'bottom-start';
            this.disabled = false;
        }
        handleActionClick() {
            if (this.disabled)
                return;
            (0, utils_1.emit)(this, eventName);
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: String, attribute: 'tooltip-placement' })
    ], IconActionElement.prototype, "tooltipPlacement", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], IconActionElement.prototype, "disabled", void 0);
    return IconActionElement;
};
exports.withIconAction = withIconAction;
/**
 * icon-button 계열(아이콘 하나로 동작을 알리는 시맨틱 버튼)이 공유하는 button+아이콘 조립 템플릿.
 * 아이콘만으로는 의미를 알 수 없으므로 aria-label은 필수이고, 같은 이름을 tooltip으로 항상 보여준다.
 */
const renderIconAction = ({ icon, ariaLabel, tooltipPlacement = 'bottom-start', disabled = false, onClick = () => { }, ariaHasPopup, ariaExpanded, ariaControls, }) => (0, lit_1.html) `
  <mm-tooltip content=${ariaLabel} placement=${tooltipPlacement}>
    <button
      slot="trigger"
      type="button"
      aria-label=${ariaLabel}
      aria-haspopup=${(0, if_defined_js_1.ifDefined)(ariaHasPopup ?? undefined)}
      aria-expanded=${(0, if_defined_js_1.ifDefined)(ariaExpanded ?? undefined)}
      aria-controls=${(0, if_defined_js_1.ifDefined)(ariaControls ?? undefined)}
      ?disabled=${disabled}
      @click=${onClick}
    >
      <mm-icon name=${icon}></mm-icon>
    </button>
  </mm-tooltip>
`;
exports.renderIconAction = renderIconAction;
/**
 * 아이콘 하나로 단일 행동만 알리는 시맨틱 버튼의 기반 클래스를 만든다.
 * 스타일과 템플릿은 계열이 공유하고, 태그명·행동 이름·레이블은 각 컴포넌트가 자기 API로 갖는다.
 * 기본 스킨이 아니면 자기 static styles로 덮고, 다른 템플릿이 필요하면
 * withIconAction으로 상태만 받아 자기 render를 쓴다.
 */
const iconActionElement = ({ event, icon, ariaLabel }) => {
    class IconActionButton extends (0, exports.withIconAction)(lit_1.LitElement, event) {
        render() {
            return (0, exports.renderIconAction)({
                icon,
                ariaLabel,
                tooltipPlacement: this.tooltipPlacement,
                disabled: this.disabled,
                onClick: this.handleActionClick,
            });
        }
    }
    IconActionButton.styles = [shared_styles_1.resetStyles, icon_button_styles_1.iconButtonStyles, icon_button_styles_1.iconButtonSecondarySkinStyles];
    return IconActionButton;
};
exports.iconActionElement = iconActionElement;
//# sourceMappingURL=data:application/json;base64,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